export default "__VITE_ASSET__B83x5Txb__"